import { Box, styled, Typography } from '@mui/material';
import { the5ersColorSchemes } from '../../../config/themes';

export const HeroBannerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  gap: '40px',
}));

export const HeroBannerTotalAndActionsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(12),
  [theme.breakpoints.down('xxl')]: {
    gap: theme.spacing(6),
  },
  [theme.breakpoints.down(theme.breakpoints.values.lg + 55)]: {
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
}));

export const HeroBannerRightSide = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const HeroBannerTotalSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(8),
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch',
  borderRadius: theme.spacing(5),
  background: theme.palette.background.hero,
  gap: theme.spacing(4),
  minWidth: 'fit-content',
  [theme.breakpoints.down('xl')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    minWidth: 0,
  },
}));

export const HeroBannerIconWrapper = styled(Box)(({ theme }) => ({
  width: theme.spacing(18.76875),
  height: theme.spacing(16.5),
  padding: theme.spacing(4, 2.875, 4, 3.1),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  borderRadius: theme.spacing(2.8875),
  backgroundColor: the5ersColorSchemes.dark.palette.primary.main, // Always #DDFD6C
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    padding: theme.spacing(3),
  },
}));

export const HeroBannerActions = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  '& > *': {
    height: theme.spacing(12),
    padding: `0 ${theme.spacing(7)}`,
    borderRadius: theme.spacing(7.5),
    fontSize: theme.spacing(5),
    lineHeight: '140%',
    letterSpacing: theme.spacing(0.0075),
    '& svg': {
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(64.75),
      fontSize: `${theme.spacing(4.5)} !important`,
      lineHeight: '100% !important',
      letterSpacing: `${theme.spacing(0.00675)} !important`,
    },
  },
}));

export const HeroBannerRequestsStatus = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: theme.spacing(6),
  flexWrap: 'wrap',
  width: '100%',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(3),
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
}));

export const StatusCardWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(6),
  gap: theme.spacing(2.5),
  flex: '1 1 0',
  alignSelf: 'stretch',
  borderRadius: theme.spacing(4),
  border: `1px solid ${theme.palette.text.fifth}`,
  background: theme.palette.text.opposite,
  pointerEvents: 'none',
  transition: 'all 0.2s ease',
  minWidth: 'fit-content',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
    minWidth: 0,
  },
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(3.5)}`,
    gap: theme.spacing(2.60075),
    flex: '1 0 0',
  },
}));

export const StatusCardText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.main,
  fontSize: theme.spacing(3),
  lineHeight: '140%',
  letterSpacing: theme.spacing(0.015),
  margin: 0,
  alignSelf: 'stretch',
  [theme.breakpoints.down('xxl')]: {
    width: theme.spacing(20.09075),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: `${theme.spacing(3)} !important`,
    width: theme.spacing(18.334),
  },
}));

export const StatusCount = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.main,
  fontSize: theme.spacing(12),
  fontStyle: 'italic',
  lineHeight: '100%',
  fontWeight: 400,
  letterSpacing: theme.spacing(-0.06),
  margin: 0,
  marginTop: 'auto',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(8),
    letterSpacing: theme.spacing(-0.04),
  },
}));

export const TotalSectionSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.white,
  fontSize: theme.spacing(4.5),
  lineHeight: '140%',
  letterSpacing: theme.spacing(0.00675),
}));

export const TotalSectionAmount = styled(Typography)(({ theme }) => ({
  color: theme.palette.white,
  fontSize: theme.spacing(12),
  fontWeight: 700,
  lineHeight: '100%',
  letterSpacing: theme.spacing(-0.06),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(8),
    letterSpacing: theme.spacing(-0.04),
  },
}));
